export class SmtpConfig {
    public id: number;
    public host?: string;
    public port?: number;
    public start_tls_enable?: number;
    public auth?: number;
    public username?: string;
    public password?: string;
    public type?: string;

    constructor(
        id: number, 
        host: string, 
        port: number,
        start_tls_enable: number,
        auth: number,
        username: string,
        password: string,
        type: string
        ) {
        this.id = id;
        this.host = host;
        this.port = port;
        this.start_tls_enable = start_tls_enable;
        this.auth = auth;
        this.username = username;
        this.password = password;
        this.type = type;
    }
}